module.exports = __webpack_public_path__ + "static/media/unlink.2b21bb43.svg";